import HistoriaLayout from './historia.layout'

export default HistoriaLayout
